import { WebHttpRequestOptions } from '@am92/web-http'

import { getMyChildrenServiceName, getMyChildrenTraceActions } from '../Actions'

import serviceActionCreatorWithTokenRotation from '~/src/Redux/serviceActionCreatorWithTokenRotation'

import { asHttp } from '~/src/Configurations/WebHttp'

async function getMyChildren() {
  const options: WebHttpRequestOptions = {
    url: '/users/me/children',
    method: 'GET'
  }

  const response = await asHttp.request(options)
  const { data: body } = response
  const { data } = body
  return data
}

const getMyChildrenService = serviceActionCreatorWithTokenRotation(
  getMyChildrenTraceActions,
  getMyChildren
)

export default getMyChildrenService
export { getMyChildrenServiceName }
